import createStore from "@/utils/create-store";
import Model from "@/models/admin/tree-types";

export default createStore({ Model });
